import type { ResultDto } from '@/api/types/swapFreeControl';

function pad(n: number) {
  return String(n).padStart(2, '0');
}

// Tenant-zone datetime: backend sends ISO; render DD/MM/YYYY HH:mm:ss, else N/A.
export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return 'N/A';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 'N/A';
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return 'N/A';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 'N/A';
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

// Added Swaps: 2dp en-US thousands; "N/A" for null/NaN.
export function fmtAddedSwaps(v: number | null | undefined): string {
  if (v == null || Number.isNaN(v)) return 'N/A';
  return v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Map a ResultDto list into a value->text lookup (enum numeric value -> display).
export function toLabelMap(list: ResultDto<number>[]): Record<number, string> {
  const map: Record<number, string> = {};
  list.forEach((r) => (map[r.value] = r.text));
  return map;
}

// Resolve the numeric enum key for a display text (used when editing a scalar
// dropdown that stores the text); falls back to the current numeric value.
export function keyOf(map: Record<number, string>, text: string, current: number): number {
  const found = Object.entries(map).find(([, t]) => t === text);
  return found ? Number(found[0]) : current;
}

export const DIRECTION_LABELS: Record<number, string> = { 0: 'Normal', 1: 'Only Pay', 2: 'Only Earn' };
export const CALC_LABELS: Record<number, string> = { 0: 'Position Based', 1: 'Net Volume' };
